import * as Sentry from '@sentry/vue';
import exposeToGlobalScope from '@/shared/utils/expose-to-global-scope';
import * as capture from './capture';
import * as context from './context';
import * as init from './init';
import * as tracing from './tracing';

// Aggregate facade that matches the legacy SentryService method surface so
// all 55 existing importers keep working through services/Sentry.js shim.
// New code should import directly from the module-specific files.
export const sentryService = {
  // init / lifecycle
  init: init.initialize,
  flush: init.flush,

  // context & session boundaries
  setSessionContext: context.setSessionContext,
  updateSessionContext: context.updateSessionContext,
  setKioskContext: context.setKioskContext,
  setDeviceContext: context.setDeviceContext,
  setCurrentStep: context.setCurrentStep,
  setLocale: context.setLocale,
  setFlowContext: context.setFlowContext,
  startSentrySession: context.startSentrySession,
  endSentrySession: context.endSentrySession,
  clearSessionContext: context.clearSessionContext,

  // capture & breadcrumbs
  captureException: capture.captureException,
  captureMessage: capture.captureMessage,
  addBreadcrumb: capture.addBreadcrumb,
  setTag: capture.setTag,
  setContext: capture.setContext,

  // attachments
  captureSessionState: capture.captureSessionState,

  // tracing & metrics
  startSpan: tracing.startSpan,
  withSpan: tracing.withSpan,
  getTraceHeaders: tracing.getTraceHeaders,
  trackMetric: tracing.trackMetric,
  incrementCounter: tracing.incrementCounter,

  // memory / leak detection
  trackMemoryUsage: tracing.trackMemoryUsage,
};

// Direct re-export for advanced usage (matches legacy export).
export { Sentry };

exposeToGlobalScope(sentryService, 'SentryService');
